import { createFileRoute } from '@tanstack/react-router'
import PaymentInformationContainer from 'Royalty/containers/PaymentInformationContainer'

export const Route = createFileRoute('/royalty/paymentinformation')({
    component: PaymentInformationContainer,
})
